import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableReceivablesManagement from "./component/tableReceivablesManagement";

function ReceivablesManagement() {
	return (
		<ToastProvider>
			<Dashboard>
				<TableReceivablesManagement />
			</Dashboard>
			<Toast />
		</ToastProvider>
	)
}

export default ReceivablesManagement